import { toast } from 'sonner';

import { ApiError } from '../api/sustain-api-request';

/**
 * Pass as the `errorHandler` on a non-form callApi to toast backend validation
 * errors (422 ConstraintViolation); other errors use the default handler.
 * Forms should route violations to their fields via addSubmitError instead.
 */
export default function toastErrorHandler(
  error: ApiError | Error,
  originalHandler: (err: ApiError | Error) => void,
) {
  if (
    error instanceof ApiError &&
    error.response.data?.['@type'] === 'ConstraintViolation'
  ) {
    const violations = error.response.data.violations as Array<{
      message: string;
    }>;
    toast.error(violations.map((violation) => violation.message).join(' '));
    return;
  }
  originalHandler(error);
}
